/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Show_Marker_Comments_HelpInputs */



/**
* | output |
* | --- |
* | "Show marker comments in timeline." |
*
* @param {Options_Editor_Show_Marker_Comments_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_show_marker_comments_help = /** @type {((inputs?: Options_Editor_Show_Marker_Comments_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Show_Marker_Comments_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher les commentaires des marqueurs dans la timeline.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Markerkommentare in der Zeitleiste anzeigen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra i commenti dei marcatori nella cronologia.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отображать комментарии к маркерам на временной шкале.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar comentarios de marcadores en la línea de tiempo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在时间轴中显示标记注释。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムラインにマーカーコメントを表示します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमलाइन में मार्कर टिप्पणियां दिखाएं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exibir comentários dos marcadores na linha do tempo.")
	return /** @type {LocalizedString} */ ("Show marker comments in timeline.")
});